import React, { useState } from 'react'
import Popover from '@material-ui/core/Popover'
import {
  ReactionSelector,
  useMessageContext,
  useTranslationContext,
} from 'stream-chat-react'

const MessagingReactionSelectorWithButton = ({ ReactionIcon }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const { isMyMessage } = useMessageContext()
  const { t } = useTranslationContext()
  const open = Boolean(anchorEl)
  const isMine = isMyMessage()

  const handleClose = () => setAnchorEl(null)

  return (
    <>
      <button
        aria-expanded={open}
        aria-haspopup="true"
        aria-label={t('aria/Open Reaction Selector')}
        className="str-chat__message-reactions-button"
        data-testid="message-reaction-action"
        onClick={event => {
          event.stopPropagation()
          setAnchorEl(previous => (previous ? null : event.currentTarget))
        }}
        type="button"
      >
        <ReactionIcon className="str-chat__message-action-icon" />
      </button>
      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{
          horizontal: isMine ? 'right' : 'left',
          vertical: 'top',
        }}
        className="messaging-reaction-selector-popover"
        disableRestoreFocus
        marginThreshold={8}
        onClose={handleClose}
        open={open}
        transformOrigin={{
          horizontal: isMine ? 'right' : 'left',
          vertical: 'bottom',
        }}
        PaperProps={{
          className: 'messaging-reaction-selector-popover-paper',
          onClick: handleClose,
        }}
      >
        <ReactionSelector reverse={isMine} />
      </Popover>
    </>
  )
}

export default MessagingReactionSelectorWithButton
